<template>
        <div>
            <!--Material textarea-->
            <div class="form-group">
                <label for="filterids" title="Comma separated or one per line">Filter IDs:</label>
                <textarea class="form-control"
                          :name="id" :id="id"
                          rows="5" @change="filterbyids" v-model="txt_val">
                </textarea>
            </div>
            <div>
                <p>
                    <strong>AND</strong>
                    <button type="button" id="" class="btn btn-cyan">
                        Submit
                    </button>

<!--                    <strong>OR</strong>-->
                </p>
            </div>
            <div id="dropzoneFileUpload" class="dropzone dz-clickable" style="visibility: hidden !important;">
                <div class="dz-default dz-message">
                    <i class="fas fa-arrow-circle-up"></i>
                        Drop files here or click to pick manually
                </div>
                    <!-- No fallback form, so this really won't work w/o JS -->
            </div>
        </div>
</template>

<script>
    export default {
        props: ['id', 'value', 'token'],

        data() {
            return {
                txt_val: "",
                myDropzone: ""
            }
        },

        computed: {
            textareaname() {
                return this.id
            }
        },

        methods: {
            broadcastEvent(v='') {
                // datatables is outside the scope of vuejs
                // hence static trigger set to send and update datatables event
                // with min, max value and the type of minmax value being updated.
                $(document).trigger('TxtAreaUpdate', [{'value': v,
                                                      'id': this.id}])
            },
            reset() {
                this.txt_val = ""
                this.myDropzone.removeAllFiles(true)
                this.broadcastEvent()
            },
            filterbyids() {
                this.broadcastEvent(this.txt_val)
            }
        },

        mounted () {
            var _this = this

            _this.myDropzone = new Dropzone("#dropzoneFileUpload", {
                url: "readProteinIds",
                maxFilesize: 2, // MB
                addRemoveLinks: true,
                dictResponseError: "Can't upload file!",
                maxFiles: 1,
                parallelUploads: 1,
                acceptedFiles: ".txt",
                params: {
                    _token: _this.token
                },
                success: function(file, response) {
                    if (response['success']) {
                        // on success of reading and parsing file
                        // add value to the text area.
                        _this.txt_val = ""
                        _this.txt_val = response['ids']

                        // boadcast event that new filter ids list is set
                        _this.broadcastEvent(_this.txt_val)

                        _this.myDropzone.removeAllFiles(true)
                    } else {
                        $(file.previewElement).addClass("dz-error").find('.dz-error-message').text("Could not read file")
                    }
                }
            });

            $(document).on('reset', _this.reset)

            // strict equality operator (===) to check whether a string is empty or not.
            if (_this.value !== "") {
                _this.txt_val = _this.value
                _this.broadcastEvent(_this.txt_val)
            }
        },
    }
</script>
